import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

const subColorMap = {
	down: 'score.down',
	up: 'score.up',
	warn: 'score.warn',
	neutral: 'text.secondary',
};

const KPICard = ({ label, value, sub, subColor, vdr, onClick }) => {
	const isVdr = !!vdr;

	return (
		<Box
			onClick={onClick}
			sx={{
				backgroundColor: isVdr ? 'vdr.bg' : 'background.paper',
				border: '0.5px solid',
				borderColor: isVdr ? 'vdr.border' : 'border.light',
				borderRadius: '8px',
				padding: '11px 13px',
				cursor: isVdr || onClick ? 'pointer' : 'default',
				'&:hover': isVdr ? { backgroundColor: 'vdr.hover' } : {},
			}}
		>
			<Typography
				sx={{
					fontSize: '11px',
					color: isVdr ? 'vdr.text' : 'text.secondary',
					mb: '1px',
				}}
			>
				{label}
			</Typography>
			<Typography
				sx={{
					fontSize: '21px',
					fontWeight: 600,
					color: isVdr ? 'vdr.text' : 'text.primary',
					lineHeight: 1.1,
				}}
			>
				{value}
			</Typography>
			{sub && (
				<Typography
					sx={{
						fontSize: '11px',
						mt: '2px',
						color: isVdr
							? 'vdr.text'
							: subColorMap[subColor] || 'text.secondary',
						opacity: isVdr ? 0.7 : 1,
					}}
				>
					{sub}
				</Typography>
			)}
		</Box>
	);
};

KPICard.propTypes = {
	label: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	sub: PropTypes.string,
	subColor: PropTypes.oneOf(['down', 'up', 'warn', 'neutral']),
	vdr: PropTypes.bool,
	onClick: PropTypes.func,
};

export default KPICard;
